<template>
  <el-dialog title="生成对账单" width="500px" :visible.sync="visible">
    <el-form label-suffix="：" ref="form" label-width="120px" :model="form" :rules="rules">
      <el-form-item label="供应商名称" prop="supplierShopId">
        <el-select style="width: 300px" v-model="form.supplierShopId" placeholder="支持搜索单选" filterable @change="supplierChange">
          <el-option v-for="item in supplierList" :key="item.shopId" :label="item.shopName" :value="item.shopId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对账日期" prop="payCheckMonth">
        <el-date-picker
          style="width: 300px"
          v-model="form.payCheckMonth"
          type="month"
          :placeholder="form.supplierShopId && !supplier.allowedPayCheckMonth ? '该企业不允许对账' : '请选择月份(需要选择供应商)'"
          :disabled="!form.supplierShopId || !supplier.allowedPayCheckMonth"
          :picker-options="pickerOptions"
          @focus="pickerMonthFocusHandle"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<style lang="scss">
.reconciled {
  position: relative;
  div {
    &::after {
      content: "已对账";
      position: absolute;
      left: 50%;
      top: 24px;
      transform: translateX(-50%);
      color: #c0c4cc;
    }
  }
  a {
    line-height: 23px !important;
    padding-bottom: 10px;
  }
}
</style>

<script>
import moment from "moment";

let timer = null;

export default {
  props: {
    supplierList: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      form: {
        payCheckMonth: "",
        supplierShopId: "",
      },
      rules: {
        payCheckMonth: [{ required: true, message: "请选择对账日期", trigger: "change" }],
        supplierShopId: [{ required: true, message: "请选择供应商名称", trigger: "change" }],
      },
      visible: false,
      supplier: {},
      pickerOptions: {
        disabledDate: (time) => {
          const allowedPayCheckMonth = moment(time).format("YYYY-MM");
          return allowedPayCheckMonth != this.supplier.allowedPayCheckMonth;
        },
        cellClassName: (time) => {
          // console.log("date", moment(time).format("YYYY"));
          timer && clearTimeout(timer);
          timer = setTimeout(() => {
            this.pickerYear = `${moment(time).format("YYYY")}年`;
            this.pickerMonthHandle();
          }, 300);
        },
      },
      yearMonthArr: [],
      pickerYear: `${moment().format("YYYY")}年`,
    };
  },
  methods: {
    open() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
      });
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { payCheckMonth, supplierShopId } = this.form;
          this.$router.push(`/purchase/generateBill?payCheckMonth=${moment(payCheckMonth).format("YYYY-MM")}&supplierShopId=${supplierShopId}`);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    generateMonths(startDate, endDate) {
      const result = [];
      let currentDate = new Date(startDate);
      const end = new Date(endDate);
      const chineseMonths = ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
      while (currentDate <= end) {
        const monthIndex = currentDate.getMonth();
        const year = currentDate.getFullYear();
        const yearMonth = `${year}年${chineseMonths[monthIndex]}`;
        result.push(yearMonth);
        currentDate.setMonth(currentDate.getMonth() + 1);
      }

      return result;
    },
    supplierChange(shopId) {
      const supplier = this.supplierList.find((item) => item.shopId === shopId) || {};
      this.supplier = supplier;
      this.form.payCheckMonth = "";
      if (supplier.hadPayCheckStartMonth && supplier.hadPayCheckEndMonth) {
        this.yearMonthArr = this.generateMonths(supplier.hadPayCheckStartMonth, supplier.hadPayCheckEndMonth);
      }
    },
    pickerMonthHandle() {
      const exceededMonth = this.yearMonthArr.filter((item) => item.includes(this.pickerYear)).map((item) => item.replace(this.pickerYear, ""));
      this.$nextTick(() => {
        const pickerChild = this.pickerMonthPicker.picker.$children[2];
        if (pickerChild) {
          for (const row of pickerChild.$el.rows) {
            for (const cell of row.cells) {
              if (exceededMonth.includes(cell.textContent)) {
                cell.classList.add("reconciled");
              } else {
                cell.classList.remove("reconciled");
              }
            }
          }
        }
      });
    },
    pickerMonthFocusHandle($picker) {
      this.pickerMonthPicker = $picker;
    },
  },
};
</script>
